import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { SUPPORTED_LANGUAGE_CODES, DEFAULT_LANGUAGE, splitLanguagePath } from './locales';
import { fillPlurals } from './plurals';

// /app/* is the authenticated zone where the user's DB language is the single
// source of truth (matches Notion, Linear, Asana, Stripe, GitHub, Vercel...).
// If a user lands on /es/app/foo we strip the prefix immediately and remember
// the hinted lang in localStorage so the unauthenticated bootstrap (e.g.
// /app/login) still renders in Spanish until DB sync takes over.
// Marketing pages keep their /<lang>/ prefix for SEO / hreflang.
(() => {
  if (typeof window === 'undefined') return;
  const { lang, rest } = splitLanguagePath(window.location.pathname);
  if (!lang) return;
  if (rest === '/app' || rest.startsWith('/app/')) {
    try { localStorage.setItem('bb_language', lang); } catch { /* storage blocked: the URL still sets it */ }
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    window.history.replaceState(null, '', `${rest}${search}${hash}`);
  }
})();

// On marketing pages /<lang>/ wins on first load. App routes were stripped above,
// so urlLang will be null there and we fall back to localStorage / browser detector.
const urlLang = (() => {
  if (typeof window === 'undefined') return null;
  return splitLanguagePath(window.location.pathname).lang;
})();

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true, // map zh-CN → zh, etc.
    load: 'languageOnly',
    ns: ['common', 'landing'],
    defaultNS: 'common',
    lng: urlLang || undefined,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Missing plural forms take the language's own text, never English (./plurals.js).
      parse: (data, lng) => fillPlurals(JSON.parse(data), lng),
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'bb_language',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
